import { Avatar } from "@mui/material";
import { Upload } from "antd";
import React, { useEffect, useState } from "react";
import { CgSpinnerTwo } from "react-icons/cg";

import { PencilIcon } from "@/Components/Icons/PencilIcon";
import { showPromiseToast } from "@/utilities/utils";

const EditUserProfileAvatar = ({
  AddUserAvatar = null,
  setAddUserAvatar = null,
  avatarFile = "",
  setAvatarFile = "",
}) => {
  const [profileUploading, setProfileUploading] = useState(false);

  const handlePreview = (file) => {
    //convert the image in base64 format & show upload new image immediately
    if (file) {
      let reader = new FileReader();
      reader.onloadend = () => {
        setAddUserAvatar(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = ({ file }) => {
    setAvatarFile(file);
    setProfileUploading(true);
    showPromiseToast(Promise.resolve(), {
      loading: "Uploading...",
      success: "User image uploaded successfully",
      error: "Failed to upload user image",
    }).finally(() => {
      setProfileUploading(false);
    });
  };

  useEffect(() => {
    if (avatarFile) {
      handlePreview(avatarFile);
    }
  }, [avatarFile]);

  return (
    <div className="Add_User_ProfileAvatar_Wrapper mt-3 flex justify-center">
      <div className="relative">
        <Avatar
          alt={AddUserAvatar}
          src={AddUserAvatar || null}
          sx={{ width: 88, height: 88 }}
        />
        <Upload
          disabled={profileUploading}
          showUploadList={false}
          rootClassName={`absolute top-0 left-0 w-full h-full`}
          maxCount={1}
          accept="image/*"
          customRequest={(file) => {
            handleChange(file);
          }}
        >
          <div
            className={`absolute bottom-0 right-0 grid h-[24px] w-[24px] place-items-center rounded-full border border-primary bg-primary text-white transition-all duration-150 ease-in ${
              !profileUploading
                ? "cursor-pointer hover:bg-white hover:text-primary"
                : ""
            }`}
          >
            {profileUploading ? (
              <CgSpinnerTwo className="buttonLoader animate-spin" />
            ) : (
              <PencilIcon />
            )}
          </div>
        </Upload>
      </div>
    </div>
  );
};

export default EditUserProfileAvatar;
